import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll"
import { NavLink as Link } from 'react-router-dom'

export const Nav = styled.nav`
    
    height: 80px;
    // margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }

    @media screen and (max-width: 768px) {
        height: 60px; /* Reduced height for mobile */
    }
`

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    max-width: 1100px;
    padding: 0 24px;

    @media screen and (max-width: 768px) {
        height: 60px; /* Match Nav height */
        padding: 0 12px; /* Reduce padding so logo isn't too centered */
    }

    @media screen and (max-width: 480px) {
        padding: 0 12px; /* Consistent small padding */
    }
    
`

export const NavLogo = styled(LinkR)`
    color: #262626;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    // margin-right: 24px;
    // margin-left: auto;
    font-weight: 600;
    text-decoration: none;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    letter-spacing: 3px;
    word-spacing: 3px;
    // transition: 0.2s ease-in-out;

    :hover { 
        color: orange;
    }
    @media screen and (max-width: 480px) {
        letter-spacing: 2px;
        font-size: 1.2rem; /* Slightly smaller font to fit better */
    }
`

export const MobileIcon = styled.div` 
        display: none;
        
        @media screen and (max-width: 768px) {
            display: block;
            font-size: 1.7rem;
            cursor: pointer;
            color: #262626;
            padding: 0.5rem; /* Reduced from 1.15rem to fit 60px height */
            font-weight: 300;
            display: flex;
            align-items: center; /* Ensure vertical center */
            height: 100%;
        }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;
    height: 100%; /* Ensure it spans full navbar height so align-items: center works correctly */

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(Link)`
    color: #262626;  /* Changed from white to match theme */
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%; 
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    letter-spacing: 1px;
    &.active {
        color: #15cdfc;
        // border-bottom: 3px solid #15cdfc;
    }
`
